import { ResourceTypeLink } from "@evergis/api";
import React, { FC } from "react";

import { ConfirmText } from "../styled";
import { DeleteProjectsDescription } from "./DeleteProjectsDescription";
import { DeleteLayersDescription } from "./DeleteLayersDescription";
import { DeleteTablesDescription } from "./DeleteTablesDescription";
import { DeleteResourcesContentProps } from "../types";

export const Content: FC<DeleteResourcesContentProps> = ({
  type,
  projects,
  layers,
  tables,
  checked,
  toggle,
  resourceDependent,
}) => {
  return (
    <ConfirmText>
      {type === ResourceTypeLink.Project && (
        <DeleteProjectsDescription
          type={type}
          projects={projects}
          layers={layers}
          tables={tables}
          checked={checked}
          toggle={toggle}
        />
      )}
      {type === ResourceTypeLink.Layer && (
        <DeleteLayersDescription
          type={type}
          projects={projects}
          layers={layers}
          tables={tables}
          checked={checked}
          toggle={toggle}
          resourceDependent={resourceDependent}
        />
      )}
      {type === ResourceTypeLink.Table && (
        <DeleteTablesDescription
          type={type}
          projects={projects}
          layers={layers}
          tables={tables}
          checked={checked}
          toggle={toggle}
        />
      )}
    </ConfirmText>
  );
};
